import React from 'react';
import { useTranslator } from '@front-activerse/common-components';
import { Container, Row, Col } from 'reactstrap';
import Layout from '../Layout/Layout';
import ActivateProductForm from './ActivateProductForm';
import { useApolloClient } from '@apollo/client';
import { UserDataQuery, removeAuthCredentials } from '@front-activerse/common-components';
import { useNavigate, Link } from 'react-router-dom';

interface IActivateProductContainer {
  activateProduct: (accessCode: string) => Promise<unknown>;
}

const ActivateProductContainer: React.FC<IActivateProductContainer> = ({ activateProduct }) => {
  const { t } = useTranslator();
  const client = useApolloClient();
  const navigate = useNavigate();

  const userData = client.readQuery({
    query: UserDataQuery,
  });

  const userEmail = userData.me.email;

  const handleChangeAccount = (event: any) => {
    event.preventDefault();
    removeAuthCredentials();
    navigate('/activation');
  };

  return (
    <Layout simpleLayout>
      <div className="page-template-auth full-height7">
        <Container className="py-xxl">
          <Row>
            <Col
              xs={12}
              md={{ size: 8, offset: 2 }}
              xl={{ size: 6, offset: 3 }}
              xxl={{ size: 4, offset: 4 }}
            >
              <h1 className="text-center title-medium semi-bold mb-xl">
                {t('couponActivation.title')}
              </h1>

              <p className="mb-xl mx-l mx-md-0">
                {t('couponActivation.activateAccessAccount.content', { userEmail: '' })}
                <br />
                <span className="semi-bold">{userEmail}</span>
              </p>

              <div className="page-container">
                <div className="auth-container">
                  <ActivateProductForm activateProduct={activateProduct} />
                </div>
              </div>

              <p className="mt-xl mx-l mx-md-0 text-center">
                {t('couponActivation.anotherAccount')}{' '}
                <Link to="#" onClick={handleChangeAccount}>
                  {t('couponActivation.changeAccount.button')}
                </Link>
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export default ActivateProductContainer;
